import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import i18n from '../../../i18n/i18n';
import { wentWrong } from "../../../utils/ToastConfig";
import axios from '../../../utils/AxiosWrapper';
import { Delete } from '../../../utils/Delete';
import { Button, IconButton, Tooltip as Tooltip2 } from '@material-ui/core';
import AddMachine from './AddMachine';
import AddIcon from '@material-ui/icons/Add';
import SearchBar from 'material-ui-search-bar';
import * as Icons from '@material-ui/icons';
import { PulseLoader } from 'react-spinners';
import { withStyles } from '@material-ui/core/styles';
import css from './viewMachines.module.css';

const commonHeaderStyle = {
    textAlign: 'center',
    textTransform: 'uppercase',
    padding: '8px 6px',
    backgroundColor: '#04764e',
    color: "#fff",
    fontSize: 13,
    lineHeight: '16px',
    whiteSpace: 'nowrap',
};

const styles = theme => ({
    primaryMain: { backgroundColor: theme.palette.primary.main },
    paginationButton: {
        borderRadius: '50%',
        width: '30px',
        height: '30px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#5EB3E4',
        color: 'white',
        border: 'none',
        cursor: 'pointer'
    },
    addActionBtn: {
        minWidth: 90,
        height: 32,
        borderRadius: 6,
        padding: '0 12px',
        fontSize: 12,
        fontWeight: 600,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
    },
    iconWrapper: {
        display: 'flex',
        justifyContent: 'center'
    },
    actionIcon: {
        color: '#4a4a4a'
    }
});

class ViewMachines extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            add: false,
            edit: false,
            delete: false,
            selectedMachine: null,
            lockSelection: false,
            searchBarValue: "",
            deleteItemId: -1,
            selectedModel: "",
            models: [],
            selectedGroup: "",
            groups: [],
            selectedSubGroup: "",
            subgroups: [],
            load: false,
            baseData: [],
            filteredData: []
        };
    }

    componentDidMount() {
        localStorage.removeItem('row');
        this.getModels();
        this.getGroups();
        this.getSubGroups();
        this.loadMachines();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.searchBarValue !== this.state.searchBarValue ||
            prevState.selectedModel !== this.state.selectedModel ||
            prevState.selectedGroup !== this.state.selectedGroup ||
            prevState.selectedSubGroup !== this.state.selectedSubGroup
        ) {
            this.applyFilters();
        }
    }

    orderMachines = (items) => {
        return items.slice().sort((a, b) => {
            const aOwned = !!a.id_pogonska_masina_klijent;
            const bOwned = !!b.id_pogonska_masina_klijent;
            if (aOwned !== bOwned) return aOwned ? -1 : 1;
            const aName = (a.display_naziv || a.pogonska_masina || '').toLowerCase();
            const bName = (b.display_naziv || b.pogonska_masina || '').toLowerCase();
            return aName.localeCompare(bName);
        });
    }

    loadMachines = () => {
        this.setState({ load: true });
        axios.get('api/machine/read', { params: { page: 0, pageSize: 2000, sorted: [], filtered: [] } })
            .then(res => {
                const rows = res.data && res.data.data ? res.data.data : [];
                const normalized = rows.map(item => ({
                    ...item,
                    display_naziv: item.naziv || item.pogonska_masina,
                    base_machine_id: item.id,
                    pogonska_masina_grupa_naziv: item.pogonska_masina_grupa_naziv || item.grupa_naziv || '',
                    pogonska_masina_podgrupa_naziv: item.pogonska_masina_podgrupa_naziv || item.podgrupa_naziv || '',
                    registarska_oznaka: item.registarska_oznaka || '',
                    gps_provajder_naziv: item.gps_provajder_naziv || '',
                    gps_broj_uredjaja: item.gps_broj_uredjaja || '',
                    id_pogonska_masina_grupa: item.id_pogonska_masina_grupa || '',
                    id_pogonska_masina_podgrupa: item.id_pogonska_masina_podgrupa || ''
                }));

                const baseById = {};
                const clientRows = [];

                normalized.forEach(item => {
                    const baseId = item.base_machine_id;
                    if (!baseById[baseId]) {
                        baseById[baseId] = {
                            ...item,
                            is_client_copy: false,
                            id_pogonska_masina_klijent: null,
                            naziv: item.pogonska_masina,
                            display_naziv: item.pogonska_masina,
                            registarska_oznaka: '',
                            gps_provajder_naziv: '',
                            gps_broj_uredjaja: ''
                        };
                    }
                    if (item.id_pogonska_masina_klijent) {
                        clientRows.push({ ...item, is_client_copy: true });
                    }
                });

                const expanded = [...Object.values(baseById), ...clientRows];

                const sorted = this.orderMachines(expanded);
                this.setState({
                    baseData: sorted,
                    filteredData: sorted,
                    load: false
                });
            })
            .catch(error => {
                this.setState({ load: false });
                wentWrong('Something went wrong, please try again!');
                console.log('Error 1 (loadMachines): ', error);
            });
    }

    applyFilters = () => {
        const { baseData, searchBarValue, selectedModel, selectedGroup, selectedSubGroup } = this.state;
        let filtered = [...baseData];

        if (searchBarValue) {
            filtered = filtered.filter(item => (item.display_naziv || '').toLowerCase().includes(searchBarValue.toLowerCase()));
        }

        if (selectedModel) {
            filtered = filtered.filter(item => item.id == selectedModel);
        }

        if (selectedGroup) {
            filtered = filtered.filter(item => item.id_pogonska_masina_grupa == selectedGroup);
        }

        if (selectedSubGroup) {
            filtered = filtered.filter(item => item.id_pogonska_masina_podgrupa == selectedSubGroup);
        }

        this.setState({ filteredData: filtered });
    }

    getModels() {
        axios.get(`api/machine/drop_down`)
            .then(res => {
                const models = res.data.data
                    .map(item => ({ id: item.id, value: item.naziv }));
                this.setState({ models });
            })
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 1 (getModels): ', error);
            })
    }

    getGroups() {
        axios.get(`api/machine_group/drop_down`)
            .then(res => {
                const groups = res.data.data
                    .map(item => ({ id: item.id, value: item.naziv }));
                this.setState({ groups });
            })
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 1 (getGroups): ', error);
            })
    }

    getSubGroups() {
        if (!this.state.selectedGroup) {
            this.setState({ subgroups: [] });
            return;
        }
        axios.get('api/machine_subgroup/drop_down', { params: { id_grupa: this.state.selectedGroup } })
            .then(res => {
                const subgroups = res.data.data
                    .map(item => ({ id: item.id, value: item.naziv }));
                this.setState({ subgroups });
            })
            .catch(error => {
                wentWrong('Something went wrong, please try again!');
                console.log('Error 1 (getSubGroups): ', error);
            })
    }

    handleSearchBar = (searchVal) => {
        this.setState({
            searchBarValue: searchVal,
        });
    }

    handleOpenNewMachine = (selectedMachine = null, isEdit = false) => {
        this.setState({
            add: true,
            edit: isEdit,
            selectedMachine,
            lockSelection: !!selectedMachine
        });
    };

    handleCloseNewMachine = () => {
        this.setState({
            add: false,
            edit: false,
            selectedMachine: null,
            lockSelection: false
        });
    }

    onCreate = () => {
        this.setState({
            add: false,
            edit: false,
            selectedMachine: null,
            lockSelection: false,
            load: true
        }, () => {
            this.getGroups();
            this.getModels();
            this.loadMachines();
        });
    }

    onDeleteClick = () => { this.setState({ delete: !this.state.delete }); };

    deleteItem = () => {
        axios.post(`api/machine/deleteFavorite`, { id_pogonska_masina_klijent: this.state.deleteItemId })
            .then(() => {
                this.setState({ delete: false, deleteItemId: -1 }, () => this.loadMachines());
            })
            .catch(err => {
                this.setState({ delete: false });
                wentWrong(i18n.t('You cannot delete a implement that is in an activity!'))
            })
    }

    handleChangeModel = (e) => {
        this.setState({ selectedModel: e.currentTarget.value }, this.applyFilters);
    }

    handleChangeGroup = (e) => {
        const selectedGroup = e.currentTarget.value;
        this.setState({ selectedGroup, selectedSubGroup: '' }, () => {
            if (selectedGroup) this.getSubGroups();
            this.applyFilters();
        });
    }

    handleChangeSubGroup = (e) => {
        this.setState({ selectedSubGroup: e.currentTarget.value }, this.applyFilters);
    }

    resetMyFilters = () => {
        this.setState({
            selectedModel: '',
            selectedGroup: '',
            selectedSubGroup: '',
            searchBarValue: ''
        }, this.applyFilters);
    }

    render() {
        const { classes } = this.props;

        const columns = [
            {
                Header: i18n.t('Title'),
                accessor: 'display_naziv',
                headerStyle: commonHeaderStyle
            },
            {
                Header: i18n.t('Model'),
                accessor: 'pogonska_masina',
                headerStyle: commonHeaderStyle
            },
            {
                Header: i18n.t('Licence plate'),
                accessor: 'registarska_oznaka',
                headerStyle: commonHeaderStyle
            },
            {
                Header: i18n.t('Machines group'),
                accessor: 'pogonska_masina_grupa_naziv',
                headerStyle: commonHeaderStyle
            },
            {
                Header: i18n.t('Machines subgroup'),
                accessor: 'pogonska_masina_podgrupa_naziv',
                headerStyle: commonHeaderStyle
            },
            // {
            //     Header: i18n.t('GPS provider'),
            //     accessor: 'gps_provajder_naziv',
            //     headerStyle: commonHeaderStyle
            // },
            // {
            //     Header: i18n.t('GPS device number'),
            //     accessor: 'gps_broj_uredjaja',
            //     headerStyle: commonHeaderStyle
            // },
            {
                width: 90,
                Header: i18n.t('Add'),
                accessor: 'add_action',
                sortable: false,
                filterable: false,
                headerStyle: commonHeaderStyle,
                Cell: cell => {
                    const owned = !!cell.row._original.id_pogonska_masina_klijent;
                    const selected = { ...cell.row._original, id_pogonska_masina: cell.row._original.id };
                    return (
                        <div className={classes.iconWrapper}>
                            <Button
                                variant="contained"
                                size="small"
                                disabled={owned}
                                className={css.addActionBtn}
                                style={owned ? { backgroundColor: '#058457', color: '#fff' } : { backgroundColor: '#58B4E5', color: '#fff' }}
                                onClick={() => this.handleOpenNewMachine(selected, false)}
                            >
                                {!owned && <AddIcon style={{ fontSize: 16, color: '#fff' }} />}
                                {owned ? <Icons.Check style={{ fontSize: 16, color: '#fff' }} /> : i18n.t('Add')}
                            </Button>
                        </div>
                    );
                }
            },
            {
                width: 80,
                Header: i18n.t('Edit'),
                accessor: 'izmena',
                getHeaderProps: () => ({
                    onClick: e => e.stopPropagation(),
                    style: { cursor: 'default' }
                }),
                headerStyle: commonHeaderStyle,
                sortable: false,
                filterable: false,
                Cell: cell => {
                    const owned = !!cell.row._original.id_pogonska_masina_klijent;
                    if (!owned) return null;
                    const selected = {
                        ...cell.row._original,
                        id: cell.row._original.id_pogonska_masina_klijent,
                        base_machine_id: cell.row._original.base_machine_id || cell.row._original.id
                    };
                    return (
                        <div className={classes.iconWrapper}>
                            <Tooltip2 title={i18n.t("Edit")}>
                                <IconButton aria-label="edit" onClick={() => this.handleOpenNewMachine(selected, true)}>
                                    <Icons.Edit className={classes.actionIcon} fontSize="default" />
                                </IconButton>
                            </Tooltip2>
                        </div>
                    );
                }
            },
            {
                width: 80,
                Header: i18n.t('Delete'),
                accessor: 'detalji',
                getHeaderProps: () => ({
                    onClick: e => e.stopPropagation(),
                    style: { cursor: 'default' }
                }),
                headerStyle: commonHeaderStyle,
                sortable: false,
                filterable: false,
                Cell: cell => {
                    const owned = !!cell.row._original.id_pogonska_masina_klijent;
                    if (!owned) return null;
                    return (
                        <div className={classes.iconWrapper}>
                            <Tooltip2 title={i18n.t("Delete")}>
                                <IconButton aria-label="Delete"
                                    onClick={() => {
                                        this.setState({
                                            deleteItemId: cell.row._original.id_pogonska_masina_klijent
                                        });
                                        this.onDeleteClick();
                                    }}
                                >
                                    <Icons.DeleteOutline className={classes.actionIcon} fontSize="default" />
                                </IconButton>
                            </Tooltip2>
                        </div>
                    );
                }
            },

        ];

        return (
            <>
                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>

                    <div className={css.searchWrap}>
                        <SearchBar
                            className={css.searchBar}
                            placeholder={i18n.t('Search by name')}
                            cancelOnEscape={true}
                            value={this.state.searchBarValue}
                            onChange={(searchValue) => this.handleSearchBar(searchValue)}
                            onCancelSearch={() => this.handleSearchBar('')}
                        />

                        {/* <Button
                            variant="fab"
                            color="primary"
                            aria-label="Add"
                            className={css.addNewBtn}
                            onClick={() => { this.handleOpenNewMachine() }}
                        >
                            <AddIcon />
                            {i18n.t('Add machines')}
                        </Button> */}
                    </div>
                    <div className={css.filtersSection}>
                        {/* <select className={css.dropDowns} value={this.state.selectedModel} onChange={this.handleChangeModel} >
                            <option value="">{i18n.t('Model')}</option>
                            {this.state.models && this.state.models.map((model, i) => (
                                <option key={i} value={model.id}>{model.value}</option>
                            ))}
                        </select> */}
                        <select className={css.dropDowns} value={this.state.selectedGroup} onChange={this.handleChangeGroup} >
                            <option value="">{i18n.t('Machines group')}</option>
                            {this.state.groups && this.state.groups.map((group, i) => (
                                <option key={i} value={group.id}>{group.value}</option>
                            ))}
                        </select>
                        {/* <select className={css.dropDowns} value={this.state.selectedSubGroup} onChange={(e) => {
                            console.log("Selected subgroup: ", e.target.value);
                            this.handleChangeSubGroup(e)
                        }} disabled={this.state.selectedGroup === ""} >
                            <option value="">{i18n.t('Machines subgroup')}</option>
                            {this.state.subgroups && this.state.subgroups.map((subgroup, i) => (
                                <option key={i} value={subgroup.id}>{subgroup.value}</option>
                            ))}
                        </select> */}
                        <button className={css.resetButton} onClick={this.resetMyFilters}>{i18n.t('Reset filters')}</button>

                    </div>
                    <div style={{ border: '1px solid #cecece', backgroundColor: '#fff', margin: '30px 30px 30px 30px', borderRadius: '3px', boxSizing: 'border-box', overflowX: 'auto', overflowY: 'hidden', boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.5)', display: 'flex', flexDirection: 'column' }}>

                        <ReactTable
                            className={css.compactTable}
                            ref={r => (this.reactTable = r)}
                            data={this.state.filteredData}
                            columns={columns}
                            sortable={false}
                            filterable={false}
                            defaultPageSize={10}
                            showPaginationBottom={true}
                            previousText={'<'}
                            nextText={'>'}
                            pageText={''}
                            ofText={i18n.t('of')}
                            showPageSizeOptions={false}
                            rowsText={''}
                            PreviousComponent={(props) => (
                                <button {...props}
                                    className={
                                        classes.paginationButton}
                                >{props.children}</button>
                            )}
                            NextComponent={(props) => (
                                <button {...props}
                                    className={
                                        classes.paginationButton}
                                >{props.children}</button>
                            )}
                            getTrProps={(state, rowInfo) => {
                                if (!rowInfo) return {};
                                const owned = !!rowInfo.original.id_pogonska_masina_klijent;
                                const rowClass = owned ? css.clientRow : '';
                                return {
                                    className: rowClass,
                                    style: {
                                        minWidth: '1200px',
                                        textAlign: 'center',
                                        paddingLeft: '10px',
                                        height: '50px',
                                        alignItems: 'center',
                                        overflowY: 'hidden',
                                        overflowX: 'hidden',
                                    }
                                };
                            }}

                            LoadingComponent={() => (
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}>
                                    <PulseLoader loading={this.state.load} />
                                </div>
                            )}

                            NoDataComponent={() => (
                                <div style={{
                                    textAlign: 'center', padding: '20px', display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    marginTop: -300
                                }}>
                                    {!this.state.load && <span>{i18n.t('No rows found')}</span>}
                                </div>
                            )}
                        />
                    </div>
                </div>
                {this.state.add && <AddMachine add={this.state.add} edit={this.state.edit} handleCreate={this.onCreate} handleClose={this.handleCloseNewMachine} data={this.state.selectedMachine} lockSelection={this.state.lockSelection} />}
                {this.state.delete && <Delete delete={this.state.delete} handleClose={this.onDeleteClick} deleteItem={this.deleteItem} />}
            </>
        );
    }
}

export default withStyles(styles)(ViewMachines);
